export default {
  "command.toggle": "Toggle debug bar",
  "command.heap": "Capture heap snapshots",
  "command.heap.description": "Saves the memory of the app and its server to a folder",
  "heap.loading": "Capturing heap snapshots…",
  "heap.done": "Heap snapshots saved",
  "heap.partial": "Some heap snapshots failed. See manifest.json.",
  "heap.failed": "Could not capture heap snapshots",
  "heap.reveal": "Show in folder",
  "status.toggle": "Toggle debug tools",
  ariaLabel: "Development performance diagnostics",
  providerAriaLabel: "Provider performance diagnostics",
  na: "n/a",
  "ttft.label": "TTFT",
  "ttft.tip": "Time from provider request dispatch to the first model output.",
  "ttfa.label": "TTFA",
  "ttfa.tip": "Time from provider request dispatch to the first answer text.",
  "tps.label": "TPS",
  "tps.tip": "Output tokens per second after the first model output.",
  "e2e.label": "E2E",
  "e2e.tip": "Time from provider request dispatch until its response stream ended.",
  "nav.label": "NAV",
  "nav.tip":
    "Last completed route transition touching a session page, measured from router start until the first paint after it settles.",
  "fps.label": "FPS",
  "fps.tip": "Rolling frames per second over the last 5 seconds.",
  "frame.label": "FRAME",
  "frame.tip": "Worst frame time over the last 5 seconds.",
  "jank.label": "JANK",
  "jank.tip": "Frames over 32ms in the last 5 seconds.",
  "long.label": "LONG",
  "long.tip": "Blocked time and long-task count in the last 5 seconds. Max task: {{max}}.",
  "delay.label": "DELAY",
  "delay.tip": "Worst observed input delay in the last 5 seconds.",
  "inp.label": "INP",
  "inp.tip":
    "Approximate interaction duration over the last 5 seconds. This is INP-like, not the official Web Vitals INP.",
  "cls.label": "CLS",
  "cls.tip": "Cumulative layout shift for the current app lifetime.",
  "mem.label": "MEM",
  "mem.tipUnavailable": "Used JS heap vs heap limit. Chromium only.",
  "mem.tip": "Used JS heap vs heap limit. {{used}} of {{limit}}.",
  "focus.label": "FOCUS",
  "focus.tip": "Force focus styles on all interactive elements",
  "focus.on": "ON",
  "focus.off": "OFF",
  "direction.label": "DIR",
  "direction.tip": "Force the full app layout direction without changing the selected language",
  "direction.ltr": "LTR",
  "direction.rtl": "RTL",
}
